const GFFunnelSteps = () => {
    (function () {
        document.addEventListener('click', function (event) {
            var trigger = event.target.closest('.donation-funnel-steps__button');

            if (!trigger) {
                return;
            }

            event.preventDefault();

            var stepper = trigger.closest('.donation-funnel-steps');
            var formWrapper = trigger.closest('.gform_wrapper');

            if (!stepper || !formWrapper) {
                return;
            }

            var formId = stepper.getAttribute('data-form-id');
            var targetPage = parseInt(trigger.getAttribute('data-target-page'), 10);
            var currentPage = parseInt(stepper.getAttribute('data-current-page'), 10);

            if (!formId || !targetPage || !currentPage) {
                return;
            }

            if (targetPage >= currentPage) {
                return;
            }

            var form = formWrapper.querySelector('form');
            var sourceInput = form
                ? form.querySelector('#gform_source_page_number_' + formId)
                : null;
            var previousButton = form
                ? form.querySelector('#gform_previous_button_' + formId)
                : null;
            var customTargetInput = stepper.querySelector('input[name="adpt_target_page"]');

            if (!form || !sourceInput || !previousButton || !customTargetInput) {
                return;
            }

            customTargetInput.value = targetPage;
            sourceInput.value = currentPage;

            previousButton.click();
        });
    })();
};

export default GFFunnelSteps;
